export const CAMPAIGN_TYPE_VACCINATION = 'V';
export const CAMPAIGN_TYPE_AWARENESS = 'A';

export const CAMPAIGN_TYPES = [
  CAMPAIGN_TYPE_VACCINATION,
  CAMPAIGN_TYPE_AWARENESS,
] as const;
export type CampaignType = (typeof CAMPAIGN_TYPES)[number];

export const VACCINATION_CAMPAIGN_TARGETS = [
  'COVID',
  'COVID_FLU',
  'COVID_RSV',
  'FLU',
  'MMR',
  'RSV',
  'MENB',
  'MENACWY',
  'HPV',
  '3IN1',
  '3IN1_HPV_MENACWY_MMR',
] as const;
export const AWARENESS_CAMPAIGN_TARGETS = ['TALKINGTHERAPIES'] as const;

// Targets that are valid for routing plans to use as comms targets
// but not for campaign targets
export const ROUTING_COMMS_TARGETS = [
  '3IN1_HPV',
  '3IN1_MENACWY',
  '3IN1_MMR',
  'HPV_MENACWY',
  'HPV_MMR',
  'MENACWY_MMR',
  '3IN1_HPV_MENACWY',
  '3IN1_HPV_MMR',
  '3IN1_MENACWY_MMR',
  'HPV_MENACWY_MMR',
] as const;

type CampaignTypeTargetMapping = {
  [key in CampaignType]:
    | typeof VACCINATION_CAMPAIGN_TARGETS
    | typeof AWARENESS_CAMPAIGN_TARGETS;
};

export const CAMPAIGN_TARGETS: CampaignTypeTargetMapping = {
  V: VACCINATION_CAMPAIGN_TARGETS,
  A: AWARENESS_CAMPAIGN_TARGETS,
} as const;

// X = Manual/Adhoc
// D = Daily
// W = Weekly
// M = Monthly
// Q = Quarterly
// A = Annually
export const ITERATION_FREQUENCY = ['X', 'D', 'W', 'M', 'Q', 'A'] as const;

// A = Automatic
// M = Manual
// S = Supervised
export const ITERATION_TYPE = ['A', 'M', 'S'] as const;
